import {
  Anchor,
  Avatar,
  Badge,
  Box,
  Card,
  Center,
  Divider,
  Group,
  ScrollArea,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { IconCamera } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { logger } from "utils/logger";
import { EmptyState } from "core/components/emptyState/EmptyState";
import { createStyles } from "@mantine/emotion";
import { getStyle } from "services/styleService";
import { useDispatch } from "react-redux";

import Moment from "react-moment";

import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import _ from "lodash";
import { getClientLabel } from "utils/helper";
import { DateDisplay } from "core/components/index";

const useStyles = createStyles((theme, _, u) => ({
  container: {
    padding: 0,
    height: "100%",
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderTopStyle: "solid",
    borderLeftStyle: "solid",
    // paddingTop: 26,
    borderColor: theme.colors.dark[4],
    [u.light]: {
      borderColor: theme.colors.gray[3],
    },
    ".mantine-Accordion-content": {
      paddingBottom: 0,
    },
    ".mantine-Accordion-control": {
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderColor: theme.colors.dark[4],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
    ".mantine-Stack-root": {
      gap: 0,
    },
    ".capture-selected > div > div:first-of-type": {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.brand[1],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
  },
  badgeIndex: {
    position: "absolute",
    left: 0,
    top: 0,
  },
}));

const LiveFeedAssetInfoPanel = ({ selectedItem, user }) => {
  const { classes } = useStyles();
  const [style, setStyle] = useState(null);

  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  // const dateArr = selectedItem.actionSort.split('-');
  // const y = dateArr[0];
  // const m = dateArr[1];
  // const d = dateArr[2];
  // const h = dateArr[3];
  // const min = dateArr[4];
  // const s = dateArr[5];

  // const captureDate = moment(selectedItem.actionSort, 'YYYY-MM-DD-hh-mm-ss');

  useEffect(() => {
    logger.log(selectedItem);

    // Create debounced version of getStyleInfo (1000ms = 1 second delay)
    const debouncedGetStyleInfo = _.debounce(async (id) => {
      const data = await getStyle(id);

      if (data) {
        logger.log(data);
        setStyle(data);
      }
      hasFetched.current = true;
    }, 1000);

    if (selectedItem && selectedItem.styleNumber) {
      if (
        !selectedItem.assets ||
        (selectedItem.assets.length === 0 && !hasFetched.current)
      ) {
        debouncedGetStyleInfo(selectedItem.styleNumber);
      }
    }

    // Clean up the debounced function when component unmounts
    return () => {
      debouncedGetStyleInfo.cancel();
    };
  }, [selectedItem]);

  logger.log(selectedItem);

  // const zoomImage = (data) => {
  //   logger.log(data);
  //   setSelectedAsset(data);
  //   setImageModalOpen(true);
  // };

  return (
    <Box className={`${classes.container} unhightable`}>
      <div style={{ width: '100%', height: "calc(100% - 46px)" }}>
        <ScrollArea sx={{ height: "100%" }}>
          {selectedItem ? (
            <Card pt="lg" style={{ background: "none" }} p={"lg"}>
              <Title className="main-content-heading" order={5} >
                {selectedItem.name}
              </Title>

              {/* <Title className="main-content-heading" order={6}>
                Style Information
              </Title> */}
              <Box>
                <Group my="md">
                  <Text size="sm" style={{ width: "30%" }} weight="500">
                    Style Number
                  </Text>
                  <div>
                    <Text size="sm">
                      <Anchor
                        component={Link}
                        to={`/distributions/${style?.styleNumber}`}
                      >
                        {style?.styleNumber}
                      </Anchor>
                    </Text>
                  </div>
                </Group>
                <Group my="md">
                  <Text size="sm" style={{ width: "30%" }} weight="500">
                    Department
                  </Text>
                  <div>
                    <Text size="sm">{style?.dept}</Text>
                  </div>
                </Group>

                <Group my="md">
                  <Text size="sm" style={{ width: "30%" }} weight="500">
                    {getClientLabel(user.clientCode, 'otbDate')}
                  </Text>
                  <div>
                    <Text size="sm">
                      {style?.otbDate && style?.otbDate.length ? (
                        <DateDisplay
                          value={style.otbDate}
                          parse="YYYY-MM-DD-hh-mm-ss"
                          format="DD/MM/YYYY"
                          trim
                        />
                      ) : (
                        ""
                      )}
                    </Text>
                  </div>
                </Group>

                <Group my="md">
                  <Text size="sm" style={{ width: "30%" }} weight="500">
                    Distribution Date
                  </Text>
                  <div>
                    <Text size="sm">
                      {style?.distributionDate &&
                      style?.distributionDate.length ? (
                        <Moment
                          date={style?.distributionDate}
                          parse="YYYY-MM-DD-hh-mm-ss"
                          format="DD/MM/YYYY"
                          trim
                        />
                      ) : (
                        ""
                      )}
                    </Text>
                  </div>
                </Group>
              </Box>
              <Divider />
              <Box mt={"xl"}>
                <Group mb="lg">
                  <Title className="main-content-heading" order={6}>
                    Tags
                  </Title>
                  {selectedItem?.tags && selectedItem.tags.length ? (
                    <PrimaryBadge>
                      {selectedItem?.tags?.split(",").length}
                    </PrimaryBadge>
                  ) : null}
                </Group>
                <Group gap={"xs"} sx={{ justifyContent: "center" }}>
                  {selectedItem?.tags && selectedItem.tags.length ? null : (
                    <Text size="sm" c={"dimmed"}>
                      No tags available
                    </Text>
                  )}
                  {selectedItem &&
                    selectedItem.tags &&
                    selectedItem.tags.length &&
                    selectedItem.tags.split(",").map((val, idx) => (
                      <Badge
                        key={idx}
                        color="gray"
                        variant="default"
                        gradient={{ from: "#ed6ea0", to: "#ec8c69", deg: 35 }}
                      >
                        {val}
                      </Badge>
                    ))}

                  {/* <Badge variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>Winter</Badge> */}
                </Group>

                {!selectedItem ||
                (selectedItem && selectedItem.assets?.length === 0) ? (
                  <EmptyState
                    caption="There are no assets"
                    style={{ height: 200 }}
                  />
                ) : null}
                {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
              </Box>
            </Card>
          ) : (
            <Center sx={{ height: "100%", minHeight: 400 }}>
              <div style={{ textAlign: "center" }}>
                <IconCamera size={48} stroke={1} />
                <Title color={"dimmed"} order={3}>
                  Select an Image
                </Title>
              </div>
            </Center>
          )}
        </ScrollArea>
      </div>
    </Box>
  );
};

export default LiveFeedAssetInfoPanel;

export function TalentList({ data }) {
  const rows = data.map((item) => (
    <tr key={item.name}>
      <td>
        <Group spacing="sm">
          <Avatar size={40} src={item.avatar} radius={40} />
          <div>
            <Text size="sm" weight={500}>
              {item.name}
            </Text>
            <Text size="xs" color="dimmed">
              {item.email}
            </Text>
          </div>
        </Group>
      </td>
    </tr>
  ));

  return (
    <Table verticalSpacing="sm">
      {/* <thead>
            <tr>
              <th>Employee</th>
              <th>Role</th>
              <th>Last active</th>
              <th>Status</th>
            </tr>
          </thead> */}
      <tbody>{rows}</tbody>
    </Table>
  );
}
